import React from 'react'
import ItemModal from '../../modals/ItemModal'
import RemoveModal from '../../modals/RemoveModal'
import { getObject, pathMaker } from '../../utils/useful'
import Pagination from '../Pagination'
import TableViewer from '../TableViewer'
import { v4 as uuidv4 } from 'uuid';

class TableViewerInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }

    updateData = () => {

    }

    openRefModal = (prop, index, reference) => {
        console.log(reference)
        this.props.openRefModal(prop, index, reference)
    }


    openAddNew = () => {
        console.log("openAddNew")
        this.setState({ currentItem: {}, currentIndex: -1 }, () => {
            setTimeout(() => {
                if (this.props.page?.addNew) {
                    let newPage = this.props.page?.addNew
                    if (this.props.page?.addNew.includes('../')) {
                        newPage = this.props.route + this.props.page?.addNew.replace('..', '')
                    }
                    // console.log(newPage)
                    this.props.history.push({ pathname: pathMaker(newPage), search: '?ref=' + pathMaker('/' + this.props.route + '/' + this.props.page?.key), state: { isAdmin: true } })
                } else {
                    this.openEditModal()
                }
            }, 100);

        })
    }

    openEditModal = (prop, index) => {
        // console.log("openEditModal")
        // console.log(index)
        this.itemModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    openRemoveModal = (prop, index) => {
        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    submitForm = (newData) => {
        // console.log(this.state.currentIndex)

        let data = this.props.data
        if(!data){
            data = []
        }
        if (this.state.currentIndex == null || this.state.currentIndex == -1) {
            if (!newData.id) {
                newData.id = uuidv4()
            }
            data.push(newData)
            // console.log("HERE@")

        } else {
            data.forEach((element, index) => {
                if (element.id == newData.id) {
                    data[index] = newData
                }
            });
        }
        // console.log(data)
        this.props.changeValue(this.props.header.key, data, this.props.extra)
        this.itemModal.modal.hideModal()
    }


    doRemove = (id, index) => {
        let data = [...this.props.data]

        data.splice(this.state.currentIndex, 1)
        this.props.changeValue(this.props.header.key, data, this.props.extra)

        // let section = this.state.currentRemoveKey ? this.state.currentRemoveKey : this.chooseCurrent().key
        // item[section].splice(index, 1)
        // this.props.changeValue(section, item[section], null, this.props.isInfoModal)
        this.removeModal.modal.hideModal()
    }


    dataFilter = (data) => {
        // console.log(this.props.header.dataFilter)
        if (this.props.header.dataFilter) {
            let newData = []
            if (Array.isArray(data)) {
                for (let i = 0; i < data.length; i++) {
                    const element = data[i];
                    // console.log(this.props.header.dataFilter.value)
                    // console.log(getObject(element, this.props.header.dataFilter.key))
                    if (getObject(element, this.props.header.dataFilter.key) == this.props.header.dataFilter.value) {
                        // console.log('PUSH')
                        newData.push(element)
                    }
                }
                // console.log(newData)
                return newData
            } else {
                return data
            }
        } else {
            return data
        }
    }


    render() {

        let data = this.dataFilter(this.props.data)
        // console.log(this.props.header?.headers)
        // console.log(this.props.data)

        return (
            <div className="w-100 h-100 mt-2">
                <div className="col-12  w-100 p-0">


                    {this.props.header?.addNew != -1 && (
                        <button onClick={() => this.openAddNew()} className="flexcc mb-1" style={{ boxShadow: '0px 0px 15px #00000005', backgroundImage: 'linear-gradient(#000,#102030)', border: '0px solid #e9eaf0', color: '#789', borderRadius: 30, padding: '7px 15px' }}>
                            <img className="mrd-2 invert" src="/images/add.svg" alt="" width="12px" />
                            <span className="text-smaller m-0 white text-bold" >Add New</span>
                        </button>
                    )}
                    <TableViewer
                        isLoading={this.state.isLoadingData}
                        headers={this.props.header?.headers}
                        page={this.props.header}
                        variables={this.props.variables}
                        data={data}
                        actions={this.props.header.actions}
                        settings={{ isSortable: false }}
                        openEditModal={this.openEditModal}
                        openRemoveModal={this.openRemoveModal}
                        openRefModal={this.openRefModal}
                        updateData={this.updateData}
                        functionsHandler={this.props.functionsHandler}

                        ref={el => this.TableViewer = el}
                    />


                    <Pagination currentPage={this.state.currentPage} totalCount={this.state.totalCount} limit={this.state.limit} changePage={this.changePage} />

                </div>


                <ItemModal
                    ref={el => this.itemModal = el}
                    page={this.props.header}
                    headers={this.props.header?.headers}
                    initData={this.state.currentItem}
                    variables={this.props.variables}
                    submitForm={this.submitForm}
                    itemAdded={this.itemAdded}
                    itemEdited={this.itemEdited}
                    functionsHandler={this.props.functionsHandler}
                    showDates={true}
                />


                <RemoveModal
                    isLoading={this.state.isLoadingRemove}
                    removeFunction={this.doRemove}
                    ref={el => this.removeModal = el}
                />

            </div>
        )
    }
}

export default TableViewerInput;